import React, { useState } from 'react';
import { Dropdown, ButtonGroup, Spinner } from 'react-bootstrap';
import { Actions } from '../../../client/Actions';
import LightButton from '../../components/button/LightButton';
import { useLoaderContext } from '../../components/loader/LoaderContext';
import ConfirmModal from '../../components/modal/ConfirmModal';


const SendMailDropdown = ({ reservationId, onSent }) => {
  const { showLoader, hideLoader } = useLoaderContext();
  const [sending, setSending] = useState(false);
  const [toConfirm, setToConfirm] = useState();

  const mailOptions = [
    { mailType: 'RESERVATION_CREATED', label: 'Rezerwacja utworzona - oczekujemy na płatność' },
    { mailType: 'RESERVATION_CONFIRMATION', label: 'Potwierdzenie rezerwacji' },
    { mailType: 'CHECKIN_REMINDER', label: 'Przypomnienie przed przyjazdem' },
    { mailType: 'RESERVATION_CANCELLED', label: 'Rezerwacja anulowana' },
  ];

  const sendMail = (mailType) => {
    showLoader();
    setSending(true);
    Actions.post(
      `/send-mail/reservation/${reservationId}/send?mailType=${mailType}`,
      null,
      () => {
        hideLoader();
        setSending(false);
        if (onSent) onSent();
      }
    );
  };

  return (
    <>
      <Dropdown as={ButtonGroup} drop={'start'}>
        <LightButton disabled={sending} size="sm">
          {sending ? <Spinner size="sm" animation="border" /> : 'Wyślij e-mail'}
        </LightButton>

        <Dropdown.Toggle split variant="light" id="dropdown-split-basic" size="sm" />

        <Dropdown.Menu>
          {mailOptions.map((opt) => (
            <Dropdown.Item key={opt.mailType} onClick={() => setToConfirm(opt.mailType)}>
              {opt.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {toConfirm &&
        <ConfirmModal
          show={!!toConfirm}
          size={"md"}
          setShow={() => setToConfirm(null)}
          onConfirm={() => sendMail(toConfirm)}
          title={mailOptions.find(o => o.mailType === toConfirm).label}
          description={'Czy napewno chcesz wysłać e-mail "' + mailOptions.find(o => o.mailType === toConfirm).label+'"'}
        />
      }
    </>
  );
};

export default SendMailDropdown;
